import { Component, ErrorHandler, OnInit, ViewChild, } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../shared/user.service';
import swal from 'sweetalert2';
import { NgForm } from '@angular/forms';


@Component({
  selector: 'app-against-notification-form5',
  templateUrl: './against-notification-form5.component.html',
  styleUrls: ['./against-notification-form5.component.css']
})
export class AgainstNotificationForm5Component implements OnInit {
   @ViewChild('ApplicationForm1') ApplicationForm1: NgForm;
app: any = {};   
  App_Reg_No: any;
  data: any;
  NO_Id: any;
  PD_Id: any;
  CA_Id: any;
  DSWOId_NORF_ID_Amount: null;
  DSWOId_NORF_Amount: null;
  CA_Id_Fk: any;
  APP_CA_Id_FK: any;
    pay_data: any;
   pay_formData: any;
    hasClickedPay = false;
 hasClickedPayId = false;
   transid : any;
  paydate :any;
  payinfo : any;
  paymentStatusappfee: any;
    responseData: any;
  paymentStatus: any;
  formInvalid = false;
   isLoading = false;
  r: any={};
  Mobile_No: any;
  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) {
  }

 ngOnInit() {



 console.log("📢 ngOnInit in LoginComponent");
     console.log(this.paymentStatusappfee);
    window.addEventListener("message", this.receivePaymentMessage.bind(this), false);
    console.log("✅ Message listener added.");
    // this.route.queryParams.subscribe(params => {
    //   this.id = params['id'];
    //   this.pdId = params['pdId'];
    //   this.role = params['role'];
    // });
    this.route.queryParams.subscribe(params => {
      if (params['data']) {

        this.responseData = params['data'];
        console.log('Received response data: ', this.responseData);
        // Use responseData as needed in your component
      }
    });

    // const urlParams = new URLSearchParams(window.location.search);
     
    //   this.transactionId = urlParams.get('txnid') || '';
    //   this.paymentStatus = urlParams.get('status') || '';
    //   this.Online_Payment_Date = urlParams.get('addedon') || '';

     
    const urlParams = new URLSearchParams(window.location.search);
     
      this.transid = urlParams.get('txnid') || '';
      this.paymentStatus = urlParams.get('status') || '';
      this.paydate = urlParams.get('addedon') || '';
      this.payinfo = urlParams.get('productinfo') || '';

      if(this.payinfo == 'Applicant-Application-Fee') {
        debugger;
        this.app.Appfee_Transaction_Id = this.transid;
        this.app.Appfee_Payment_Date = this.paydate;
        this.paymentStatusappfee = this.paymentStatus;
      }
          if (
        localStorage.getItem('applicationFeePaid') === 'true' ||
        localStorage.getItem('idAmountPaid') === 'true'
    ) {
        this.addBeforeUnloadProtection();
    }








  this.route.queryParams.subscribe(params => {
    this.App_Reg_No = params['App_Reg_No'];
    if (!this.App_Reg_No || !sessionStorage.getItem('step4Completed')) {
      this.router.navigate(['/applicant-register']);
      return;
    }
    sessionStorage.removeItem('step4Completed');  // ← consume
    this.app.APP_Not_Id_Fk = params['APP_Not_Id_Fk'];
    this.app.APP_Project_id_fk = params['APP_Project_id_fk'];
    this.app.APP_CA_Id_FK = params['APP_CA_Id_FK'];

    
    this.app.Applicant_Name = params['Applicant_Name'];
    this.app.Email_Address = params['Email_Address'];
    this.app.Mobile_No = params['Mobile_No'];
    // this.Mobile_No = params['Mobile_No'];
    this.app.Village_Mohalla = params['Village_Mohalla'];
    this.app.Post_Office = params['Post_Office'];
    this.app.Pincode = params['Pincode'];
     this.app.DI_District = params['DI_District'];
    this.app.APP_AnnualIncome = params['APP_AnnualIncome'];
    


  //this.app.App_Reg_No = params['App_Reg_No'];
  this.app.App_Reg_No = this.App_Reg_No
    // ✅ VERY IMPORTANT
    this.NO_Id = Number(this.app.APP_Not_Id_Fk);
    this.PD_Id = Number(this.app.APP_Project_id_fk);
    this.CA_Id = Number(this.app.APP_CA_Id_FK);
    // this.app.App_Reg_No = this.App_Reg_No;
    this.getCategoryname();
      this.GetByIdVerifypaymentdetails();
  });

  this.app.Appfee_payment_Method = 'Online';
//   setTimeout(() => {
//   if (this.paymentStatusappfee === 'success') return;

//   alert('आवेदन शुल्क भुगतान प्रक्रिया (Application Fee Payment Process):\n\nभुगतान विंडो एक नए टैब में खुलेगी। कृपया सुनिश्चित करें कि आपके ब्राउज़र में पॉपअप सक्षम हैं।\n\nThe payment window will open in a new tab. Please ensure that popups are enabled in your browser.');
// }, 2000);
  //    setTimeout(() => {
  //     debugger;
  //       if (this.paymentStatusappfee === 'success') {
  //   return;
  // }

  //   const testWindow = window.open('', '_blank', 'width=1,height=1');

  //   if (!testWindow || testWindow.closed || typeof testWindow.closed === 'undefined') {
  //     swal({
  //       title: 'Popups Blocked! (पॉपअप अवरुद्ध है!)',
  //       html: `
  //         <p>Your browser is blocking popups. The payment window will not open unless you allow popups for this site.</p>
  //         <p style="margin-top:10px; color:#555; font-size:13px;">
  //           आपका ब्राउज़र पॉपअप को ब्लॉक कर रहा है। जब तक आप इस साइट के लिए पॉपअप की अनुमति नहीं देते, भुगतान विंडो नहीं खुलेगी।
  //         </p>
  //       `,
  //       type: 'warning',
  //       confirmButtonText: 'OK, I will enable popups (मैं पॉपअप सक्षम करूंगा)',
  //       confirmButtonColor: '#d9534f'
  //     });
  //   } else {
  //     // Popups allowed — close test window silently
  //     testWindow.close();
  //   }
  // }, 5000);

}
// APP_Not_Id_Fk, APP_Project_id_fk, APP_CA_Id_FK

    onPaymentModeChangeappfee(mode: string): void {
      // debugger;
  
  if (mode === 'Online') {
    this.app.Appfee_Bank_Name = null;
    this.app.Appfee_branch = null;
    this.app.Appfee_Transaction_Id= null; // Clear Bank Challan Number
    this.app.Appfee_Payment_Date = null;
    
    // this.paidAmount = this.paidAmount
    // this.PCA_InstallmemntNo = this.PCA_InstallmemntNo
  }
}








GetByIdVerifypaymentdetails() {
  debugger

  if (!this.app.Mobile_No) {
    console.error('Mobile_No is missing');
    return;
  }

  document.getElementById('loader-spinner').style.display = "block";

  this.userService.GetByIdverificationpaymentdetsils(this.app.Mobile_No)
    .subscribe(
      (response: any) => {

        console.log("Full API Response:", response);

        if (response && response.data && response.data.length > 0) {

          this.r = response.data[0];   // ✅ FIXED

          this.DSWOId_NORF_Amount = this.r.Amount;
          this.app.Appfee_Transaction_Id = this.r.TxnId;
          this.paymentStatusappfee = this.r.Status;
          this.app.Appfee_Payment_Date = this.r.AddedOn;
          this.app.APP_NomineeName = this.r.APP_NomineeName;
          // this.app.APP_AnnualIncome = this.r.APP_AnnualIncome;
          this.app.APP_AnnualIncome = this.r.APP_AnnualIncome != null 
  ? this.r.APP_AnnualIncome.toString() 
  : '';

        }

        document.getElementById('loader-spinner').style.display = "none";
      },
      (error) => {
        console.error(error);
        document.getElementById('loader-spinner').style.display = "none";
      }
    );
}
 
   getCategoryname() {
debugger
  if (!this.NO_Id || !this.PD_Id || !this.CA_Id) {
    console.error("Missing required parameters");
    return;
  }

  document.getElementById('loader-spinner').style.display = "block";

  this.userService
    .getCategoryname(this.NO_Id, this.PD_Id, this.CA_Id)
    .subscribe({
      next: (response: any) => {
        this.DSWOId_NORF_Amount = response.DSWOId_NORF_Amount;
        this.DSWOId_NORF_ID_Amount = response.DSWOId_NORF_ID_Amount;
        document.getElementById('loader-spinner').style.display = "none";
      },
      error: (error) => {
        console.error(error);
        document.getElementById('loader-spinner').style.display = "none";
      }
    });
}






   beforeUnloadHandler = (event: BeforeUnloadEvent) => {
  event.preventDefault();
  event.returnValue = ''; // Standard way to show browser alert on close.
};

addBeforeUnloadProtection() {
  window.addEventListener('beforeunload', this.beforeUnloadHandler);
}

removeBeforeUnloadProtection() {
  window.removeEventListener('beforeunload', this.beforeUnloadHandler);
}


onTransactionIdChangeAPPFEE(value: string): void {
  // debugger;
  if (this.paymentStatusappfee !== 'failure') {
    this.app.Appfee_Transaction_Id = value;
  }
}


 trustedOrigins = [
      //'http://localhost:4200',        // your Angular app origin
     'https://portalbshb.esdinfra.com',

    //'http://localhost:14080',     // your payment API origin
    'https://BSHBAPI.esdinfra.com',

    'https://testpay.easebuzz.in'   // Payment provider domain
  ];

  receivePaymentMessage(event: MessageEvent) {
    //debugger;

    console.log("📬 Received message:", event);


    // if (!this.trustedOrigins.includes(event.origin)) {
    //   console.warn("Blocked origin:", event.origin);
    //   return;
    // }


    //const data = event.data;
    // if(data.productinfo == 'Applicant-Application-Fee') {
    //   if (data && data.txnid && data.status) { 
    //   this.app.Appfee_Transaction_Id = data.txnid;
    //   this.paymentStatusappfee = data.status;
    //   this.app.Appfee_Payment_Date = data.addedon;
    //     console.log("saheb transaction Id :",  this.app.Appfee_Transaction_Id);
    //   console.log("saheb payment Status :", this.paymentStatusappfee);
    //   console.log("saheb Online Payment Date :", this.app.Appfee_Payment_Date);
    //   }
    //     else {
    //   console.warn("⚠️ Received message does not contain expected fields:", data);
    // }
    // }


    //  else if(data.productinfo == 'Applicant-ID-Amount') {
    //   if (data && data.txnid && data.status) { 
    //        this.app.ID_Transaction_Id = data.txnid;
    //       this.paymentStatusIDamount = data.status;
    //       this.app.ID_Payment_Date = data.addedon;

    //     console.log("saheb transaction Id :", this.transactionId);
    //   console.log("saheb payment Status :", this.paymentStatusIDamount);
    //   console.log("saheb Online Payment Date :", this.app.ID_Payment_Date);
    //   }
    //     else {
    //   console.warn("⚠️ Received message does not contain expected fields:", data);
    // }
    // }
   

    const data = event.data || {};
    const { txnid, status, addedon, productinfo } = data;
    if (productinfo === 'Applicant-Application-Fee') {
      if (txnid && status) {
        this.app.Appfee_Transaction_Id = txnid;
        this.paymentStatusappfee = status;
        console.log(this.paymentStatusappfee);
        this.app.Appfee_Payment_Date = addedon || null;

        console.log("saheb transaction Id :", this.app.Appfee_Transaction_Id);
        console.log("saheb payment Status :", this.paymentStatusappfee);
        console.log("saheb Online Payment Date :", this.app.Appfee_Payment_Date);
                if (this.paymentStatusappfee === 'success') {
                localStorage.setItem('applicationFeePaid', 'true');
                this.addBeforeUnloadProtection();
            }
            else if (this.paymentStatusappfee != 'success'){
              this.hasClickedPay = false;
            }
      } else {
        console.warn("⚠️ Received message does not contain expected fields:", data);
        this.hasClickedPay = false;
      }
    }
   



      

    // if (data && data.txnid && data.status) {
    //   this.transactionId = data.txnid;
    //   this.paymentStatus = data.status;
    //   this.Online_Payment_Date = data.addedon;
    //   // Show alert or update UI
    //   //alert(`Payment Success!\nTransaction ID: ${this.transactionId}\nStatus: ${this.paymentStatus}`);
    //   console.log("saheb transaction Id :", this.transactionId);
    //   console.log("saheb payment Status :", this.paymentStatus);
    //   console.log("saheb Online Payment Date :", this.Online_Payment_Date);

      // Optionally: enable Save button or auto-submit
        else {
      console.warn("⚠️ Received message does not contain expected fields:", data);
    }
  
    }
//3-7-2026
  payment() {
    debugger
     if (this.hasClickedPay) return;
     //this.checkPopupPermission();

  this.hasClickedPay = true; // Disable button on first click
    //saheb
    //debugger;
    //this.getCategoryname(this.NO_Id,this.PD_Id,this.CA_Id_Fk);

    //this.ApplicationForm.value.ID_Paid_Amount = this.data.DSWOId_NORF_ID_Amount;
    // this.ApplicationForm.value.Appfee_Paid_Amount = this.DSWOId_NORF_Amount ;
    /*
    if (!this.registerForm || !this.registerForm.form) {
      alert("Form not initialized.");
      return;
    }
 
    if (!this.registerForm.valid) {
      console.warn("Form is invalid.");
      return;
    }
    */

    //console.log('registerForm object:', this.registerForm);
    //console.log('registerForm.value:', this.registerForm.value);

    // Find the district object by ID
    // const selectedDistrict = this.Districts.find(
    //   d => Number(d.DI_Id) === Number(this.ApplicationForm.value.District_Id_Fk)
    // );

    // console.log('selected dirst name :', selectedDistrict.DI_District);
    // let fullDistrictName = selectedDistrict.DI_District;  // "Bhagalpur(भागलपुर)"
    let englishDistrictName =   this.app.DI_District.split('(')[0].trim();
    console.log('english dirst name :', englishDistrictName);

    this.pay_formData = this.ApplicationForm1.value;

    //  let firstname1= this.registerForm.value.Applicant_Name;
    //  let email1= this.registerForm.value.Email;
    // let  phoneno1= this.registerForm.value.Mobile_No;
    // let  amount1="100.00";
    // let  productinfo1= "Customer Registration Fee";
    // let  address1=this.registerForm.value.Village_Mohalla;
    //  let address2= this.registerForm.value.Post_Office;
    //  let city1=englishDistrictName;
    // let  zipcode1= this.registerForm.value.Pincode;

    console.log("Form data inside payment():", JSON.stringify(this.pay_formData));
    const paydata = {
      firstname: this.app.Applicant_Name,
      email:  this.app.Email_Address ,
      phoneno:  this.app.Mobile_No ,
      // amount: this.ApplicationForm.value.Appfee_Paid_Amount,
      amount: this.DSWOId_NORF_Amount,
      productinfo: "Applicant-Application-Fee",
      address1: this.app.Village_Mohalla,
      address2:  this.app.Post_Office,
      city: englishDistrictName,
      zipcode: this.app.Pincode,

    };
    console.log("requist  payment():", JSON.stringify(paydata));
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.Postpayment(paydata);
    this.data.subscribe(
      (response) => {
        document.getElementById('loader-spinner').style.display = "none";
        // registerForm.reset();
        console.log('selected Response :', response);
        this.data = response;
        this.pay_data = this.data.data;
        console.log('pay data :' + this.pay_data);
        this.getCategoryname();
        // Construct Easebuzz URL
        //for staging 
       const easebuzzUrl = `https://testpay.easebuzz.in/pay/${this.pay_data}`;
       //for live
        // const easebuzzUrl = `https://pay.easebuzz.in/pay/${this.pay_data}`;

        // Open the payment window (can be in a new tab or same tab)
        // window.open(easebuzzUrl, "_blank");  // Opens in a new tab
        //this.getCategoryname(this.NO_Id,this.PD_Id,this.CA_Id_Fk);
        // OR use "_self" to open in the same tab
        // window.open(easebuzzUrl, "_self");
        // this.router.navigate(['/payment-success']);
          const paymentWindow = window.open(easebuzzUrl, "_blank");
//           if (!paymentWindow || paymentWindow.closed || typeof paymentWindow.closed === 'undefined') {
//   this.hasClickedPay = false;
//   swal(
//     'Popup Blocked! (पॉपअप अवरुद्ध है!)',
//     'Your browser has blocked the payment window. Please allow popups for this site and try again.\n\nआपके ब्राउज़र ने भुगतान विंडो को अवरुद्ध कर दिया है। कृपया इस साइट के लिए पॉपअप अनुमति दें और पुनः प्रयास करें।',
//     'warning'
//   );
//   return;
// }

      // Poll every 500ms to check if the payment window is closed
      const checkClosed = setInterval(() => {
        if (paymentWindow && paymentWindow.closed) {
          clearInterval(checkClosed);
          this.hasClickedPay = false; // re-enable the button
          console.log("Payment window closed, button re-enabled");
        }
      }, 500);



      },
      (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      }
    );
    // this.DSWOId_NORF_Amount = paydata.amount

  }

// payment() {
//   if (this.hasClickedPay) return;
//   this.hasClickedPay = true;

//   // ✅ Open blank window IMMEDIATELY inside the user gesture — browsers allow this
//   const paymentWindow = window.open('', '_blank');

//   let englishDistrictName = this.app.DI_District.split('(')[0].trim();
//   console.log('english district name:', englishDistrictName);

//   this.pay_formData = this.ApplicationForm1.value;

//   const paydata = {
//     firstname: this.app.Applicant_Name,
//     email: this.app.Email_Address,
//     phoneno: this.app.Mobile_No,
//     amount: this.DSWOId_NORF_Amount,
//     productinfo: 'Applicant-Application-Fee',
//     address1: this.app.Village_Mohalla,
//     address2: this.app.Post_Office,
//     city: englishDistrictName,
//     zipcode: this.app.Pincode,
//   };

//   console.log('request payment():', JSON.stringify(paydata));
//   document.getElementById('loader-spinner').style.display = 'block';

//   this.data = this.userService.Postpayment(paydata);
//   this.data.subscribe(
//     (response) => {
//       document.getElementById('loader-spinner').style.display = 'none';
//       console.log('selected Response:', response);
//       this.data = response;
//       this.pay_data = this.data.data;
//       console.log('pay data:' + this.pay_data);
//       this.getCategoryname();

//       // for staging
//       const easebuzzUrl = `https://testpay.easebuzz.in/pay/${this.pay_data}`;
//       // for live
//       // const easebuzzUrl = `https://pay.easebuzz.in/pay/${this.pay_data}`;

//       // ✅ Check if the blank window we opened is still valid
//       if (!paymentWindow || paymentWindow.closed || typeof paymentWindow.closed === 'undefined') {
//         // Popup was blocked — fall back to same-tab navigation
//         // ngOnInit already reads txnid/status/addedon/productinfo from URL on return
//         console.warn('Popup blocked — falling back to same-tab redirect');
//         window.location.href = easebuzzUrl;
//         return;
//       }

//       // ✅ Popup is open — navigate the already-open window to Easebuzz
//       paymentWindow.location.href = easebuzzUrl;

//       // ✅ Poll every 500ms to detect when user closes the payment window
//       const checkClosed = setInterval(() => {
//         if (paymentWindow && paymentWindow.closed) {
//           clearInterval(checkClosed);
//           this.hasClickedPay = false;
//           console.log('Payment window closed, button re-enabled');
//         }
//       }, 500);
//     },
//     (error) => {
//       document.getElementById('loader-spinner').style.display = 'none';

//       // ✅ Close the blank window if the API call failed — don't leave it dangling
//       if (paymentWindow && !paymentWindow.closed) {
//         paymentWindow.close();
//       }
//       this.hasClickedPay = false;

//       if (error.status === 401) {
//         this.errorHandler.handleError(error);
//       } else if (error.status === 400) {
//         swal('Warning!', error.error.Message, 'warning');
//       }
//     }
//   );
// }



SaveStep5(form: NgForm) {

  if (form.invalid) {
    this.formInvalid = true;
    return;
  }

  this.formInvalid = false;
  this.isLoading = true;

  // ✅ Make sure correct property name
  this.app.App_Reg_No = this.app.App_Reg_No;
this.app.Appfee_Paid_Amount = this.DSWOId_NORF_Amount;
  console.log("Final Payload:", this.app);

  this.userService
    .Step5_UpdateappfeepaymentDetails(this.app)
    .subscribe({
      next: (res: any) => {
        this.isLoading = false;
        swal('Success!', 'Application Fees Saved Successfully, Please continue with Final Step', 'success');
        // this.router.navigate(['/against-notification-form6']);
                    
// this.router.navigate(
//   ['/against-notification-form6'],
//   { 
//     queryParams: { 
//       APP_Not_Id_Fk: res.APP_Not_Id_Fk,
//       APP_Project_id_fk: res.APP_Project_id_fk,
//       APP_CA_Id_FK: res.APP_CA_Id_FK,
//       App_Reg_No: res.App_Reg_No,
//       Applicant_Name: res.Applicant_Name,
//       Email_Address: res.Email_Address,
//       Mobile_No: res.Mobile_No,
//       Village_Mohalla: res.Village_Mohalla,
//       Post_Office:res.Post_Office,
//       Pincode: res.Pincode,
//       DI_District: res.DI_District,
//       APP_AnnualIncome: res.APP_AnnualIncome

//       Appfee_Payment_Mode: res.Appfee_Payment_Mode,
//   Appfee_payment_Method: res.Appfee_Payment_Mode,
//   "Appfee_Transaction_Id": "txn_jP7TV5RaZMY6m7cf",
//   "Appfee_Payment_Date": "2026-02-27T10:08:35",
//   "Appfee_Paid_Amount": 200.0,
//   "Appfee_Bank_Name": null,
//   "Appfee_branch": null,
//   "APP_DI_Id_FK": 17

//     } 
//   }
// );
sessionStorage.setItem('step5Completed', '1');
this.router.navigate(
  ['/against-notification-form6'],
  { 
    queryParams: { 
      APP_Not_Id_Fk: res.APP_Not_Id_Fk,
      APP_Project_id_fk: res.APP_Project_id_fk,
      APP_CA_Id_FK: res.APP_CA_Id_FK,
      App_Reg_No: res.App_Reg_No,
      Applicant_Name: res.Applicant_Name,
      Email_Address: res.Email_Address,
      Mobile_No: res.Mobile_No,
      Village_Mohalla: res.Village_Mohalla,
      Post_Office: res.Post_Office,
      Pincode: res.Pincode,
      DI_District: res.DI_District,
      APP_AnnualIncome: res.APP_AnnualIncome,  // ✅ comma added here

      Appfee_Payment_Mode: res.Appfee_Payment_Mode,
      Appfee_payment_Method: res.Appfee_payment_Method,
      Appfee_Transaction_Id: res.Appfee_Transaction_Id,
      Appfee_Payment_Date: res.Appfee_Payment_Date,
      Appfee_Paid_Amount: res.Appfee_Paid_Amount,
      Appfee_Bank_Name: res.Appfee_Bank_Name,
      Appfee_branch: res.Appfee_branch,
      APP_DI_Id_FK: res.APP_DI_Id_FK
    } 
  }
);
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Error saving data', err);
        alert('Something went wrong!');
      }
    });
}

}




// WEBPACK FOOTER //
// ./src/app/registration/against-notification-form5/against-notification-form5.component.ts